export const currencyOptions = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'HKD', symbol: 'HK$', name: 'Hong Kong Dollar' },
  { code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar' },
  { code: 'NOK', symbol: 'kr', name: 'Norwegian Krone' },
  { code: 'KRW', symbol: '₩', name: 'South Korean Won' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'BRL', symbol: 'R$', name: 'Brazilian Real' },
  { code: 'MXN', symbol: 'MX$', name: 'Mexican Peso' },
  { code: 'BTC', symbol: '₿', name: 'Bitcoin' },
  { code: 'ETH', symbol: 'Ξ', name: 'Ethereum' },
] as const;

export type DisplayCurrency = typeof currencyOptions[number]['code'];
export const isDisplayCurrency = (value: unknown): value is DisplayCurrency =>
  currencyOptions.some(option => option.code === value);

export function getDisplayRate(currency: DisplayCurrency, fiatPrice: (symbol: string) => number, cryptoPrice: (symbol: string) => number): number | null {
  if (currency === 'USD') return 1;
  const valid = (rate: number) => Number.isFinite(rate) && rate > 0;
  if (currency === 'BTC' || currency === 'ETH') {
    const price = cryptoPrice(`${currency}USDT`);
    return valid(price) ? 1 / price : null;
  }
  const direct = fiatPrice(`USD/${currency}`);
  if (valid(direct)) return direct;
  const inverse = fiatPrice(`${currency}/USD`);
  return valid(inverse) ? 1 / inverse : null;
}

export function formatDisplayAmount(amount: number, currency: DisplayCurrency, rate: number | null): string {
  if (rate === null) return '—';
  const symbol = currencyOptions.find(option => option.code === currency)!.symbol;
  const converted = amount * rate;
  const digits = currency === 'BTC' || currency === 'ETH' ? 8 : 2;
  return `${converted < 0 ? '-' : ''}${symbol}${Math.abs(converted).toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
}
